import React from 'react';
import { Organization } from '../../../types/domain';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Card } from '../../../components/ui/Card';
import {
  Settings,
  CheckCircle2,
  Copy,
  Save,
} from 'lucide-react';

interface OrganizationGeneralSettingsTabProps {
  currentOrg: Organization | null;
  orgName: string;
  onOrgNameChange: (val: string) => void;
  canManageOrg: boolean;
  isSavingOrg: boolean;
  onSaveOrg: (e: React.FormEvent) => void;
  copiedOrgId: boolean;
  onCopyOrgId: () => void;
}

export const OrganizationGeneralSettingsTab: React.FC<OrganizationGeneralSettingsTabProps> = ({
  currentOrg,
  orgName,
  onOrgNameChange,
  canManageOrg,
  isSavingOrg,
  onSaveOrg,
  copiedOrgId,
  onCopyOrgId,
}) => {
  return (
    <Card padding="lg" className="space-y-4">
      <h2 className="text-sm font-semibold text-cf-textPrimary flex items-center gap-2">
        <Settings size={16} className="text-cf-orange" />
        <span>Details</span>
      </h2>

      <form onSubmit={onSaveOrg} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Organization Name"
            type="text"
            required
            size="sm"
            disabled={!canManageOrg}
            value={orgName}
            onChange={(e) => onOrgNameChange(e.target.value)}
          />

          <Input
            label="Organization Slug"
            type="text"
            disabled
            size="sm"
            value={currentOrg?.slug || ''}
          />
        </div>

        <Input
          label="Organization UUID"
          type="text"
          readOnly
          size="sm"
          mono
          value={currentOrg?.id || ''}
          rightAction={
            <Button
              type="button"
              variant="ghost"
              size="xs"
              onClick={onCopyOrgId}
              icon={copiedOrgId ? <CheckCircle2 size={13} className="text-emerald-400" /> : <Copy size={13} />}
              className="h-auto py-0 px-1"
            >
              {copiedOrgId ? 'Copied' : 'Copy'}
            </Button>
          }
        />

        {canManageOrg && (
          <div className="flex justify-end pt-2">
            <Button
              type="submit"
              variant="primary"
              size="xs"
              disabled={isSavingOrg || !orgName.trim()}
              loading={isSavingOrg}
              icon={<Save size={13} />}
            >
              Save Organization
            </Button>
          </div>
        )}
      </form>
    </Card>
  );
};
